import { BaseService } from '@/services/base.service';
import { ContactMailRequestDTO } from '../model/ContactMailRequestDTO';
import { UniversalFormMailRequestDTO } from '../model/UniversalFormMailRequestDTO';
import { RegistrationMailRequestDTO } from '../model/RegistrationMailRequestDTO';
import { ReservationMailRequestDTO } from '../model/ReservationMailRequestDTO';

export class MailService extends BaseService {
	async sendContactMail(mailRequest: ContactMailRequestDTO) {
		return await this.post('/api/mail/send-contact-mail', mailRequest);
	}

	async sendRegistrationMail(mail: string) {
		return await this.post('/WebServices/SessionUpdater.asmx/SendMailRegistrationHomepage', mail, { headers: { "Content-Type": "text/plain" } });
	}

	async sendUniversalFormMail(mailRequest: UniversalFormMailRequestDTO) {
		return await this.post('/api/mail/send-universal-form-mail', mailRequest);
	}

	//Registrační formulář - přidání prvku + automatická odpoveď (Požadavek #31017)
	async sendRegistrationFormMail(mailRequest: RegistrationMailRequestDTO) {
		return await this.post('/api/mail/send-registration-form-mail', mailRequest);
	}

	async sendReservationMail(mailRequest: ReservationMailRequestDTO) {
		return await this.post('/api/mail/send-reservation-mail', mailRequest);
	}
}
